import Footer from "./Footer";
import LandHeader from "./LandHeader";

export default function About() {
  var canonical = document.querySelector('link[rel="canonical"]');
  if (canonical !== null) {
    canonical.href = `https://sinatether.com/about`;
  }

  return (
    <>
      <LandHeader />

      <div>
        <div className="about-us-main"></div>

        <div className="card-about-content">
          <img
            className="img43435"
            src="https://static.sinatether.com/images/main-logo.svg"
            alt="درباره صرافی ارز دیجیتال سینا تتر"
          />

          <div>
            <p className="content200">
              صرافی سینا تتر برخواسته از شرکت سینا اکسین رایان که به‌ صورت خاص و
              تخصصی در زمینه فناوری‌های بلاک‌چین و ارز دیجیتال فعالیت دارد و
              همچنین، این شرکت متکی به مجموعه سهام‌داران حقیقی و حقوقی مطرح و
              صاحب‌نام است. صرافی سینا تتر از سال ۱۴۰۰ با همکاری تعدادی از
              دانشجویان دانشگاه صنعتی امیر کبیر و شهید بهشتی با هدف رشد و توسعه
              بازار رمز ارزها شکل گرفته و قدم به قدم با مطالعه و بررسی نیازهای
              کاربران، گام‌های جدیدی رو به جلو برمی‌دارد و پذیرای پیشنهادات و
              انتقادات ارزشمند تمامی کاربران می‌باشد تا بتواند به شکل صحیح به
              آن‌ها پاسخ دهد. از مزایای صرافی ارز دیجیتال سینا تتر، نرخ جذاب و
              معقولانه تتر و سایر رمز ارزها با تنوع بالا بیش از ۵۰۰ رمز ارز،
              امکان درخواست اضافه کردن رمز ارز دلخواه به لیست، جوایز ثبت نام،
              دعوت و همکاری در فروش با ثبت نام و استفاده از لینک رفرال در حساب
              کاربری هر شخص می‌باشد.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
